import { ProfileScreen } from '@/modules/profile';
export default ProfileScreen;


